import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    Sidebar_drawer: null,
    Customizer_drawer: false,
    SidebarColor: "white", //Change Sidebar Color || '#1d2228', | "#2b2b2b" | "rgb(44, 59, 164)" | "rgb(96, 44, 164)" | "rgb(151, 210, 219)" | "rgb(77, 86, 100)"
    SidebarBg: "",
    navbarColor: "white",
    setHorizontalLayout: false, // Horizontal layout
    signedIn:false,
    user: {},
    userInfo:{},
    userList:[],
    facList:[],
    companies:["AO","DemoCo","DigiMedix"],
    profiles:[{text:"Admin",value:"admin"},{text:"Manager",value:"manager"},{text:"Coder",value:"coder"}],
    facilities:["default","WMH","Test_Fac","Test_Pro","Test_Tech","Test_ProTech"],
    apps:[
      {label:"AbacusOps",value:"abacusops"},
      {label:"ExperiCoder",value:"expericoder"},
      {label:"QuickSight",value:"quicksight"},
    ],
    chargeTypes:["PRO","TECH"],
    codeTypes: ["EM", "CPT", "HCPCS", "DX"],
    tools: [{label:"EM Pro Lite",value:"EM_TOOL_PRO_LT"},{label:"EM ACEP Lite",value:"EM_TOOL_ACEP_LT"}],
    statuses: ["NEW", "IN PROGRESS", "INCOMPLETE", "DEFICIENT", "WAITING", "UPDATED", "QA", "COMPLETE", "EXPORT"],
    noteTypes: [{"value": "internal","label": "Internal"}, {"value": "external","label": "External"}],
    dischargeReasons:[{"value":"AIP","label":"AIP - Admitted as Inpatient"},{"value":"SDC","label":"SDC - Admitted to WMH SDC"},{"value":"AMA","label":"AMA - Against Medical Advice"},{"value":"AMANOTSEEN","label":"AMANOTSEEN - AMA NOT SEEN BY PHYS"},{"value":"CORFAC","label":"CORFAC - Correctional Facility"},{"value":"SWING","label":"SWING - DC To Swing Bed at WMH"},{"value":"SNF","label":"SNF - DC/Transfer to SNF"},{"value":"ICF","label":"ICF - DC/TX to Assisted Living Fac"},{"value":"STH","label":"STH - DC/TX to Other Acute Care Hospice"},{"value":"XPH","label":"XPH - DC/TX to Psychiatric Hosp/Unit"},{"value":"HOS","label":"HOS - Discharge Home with Hospice"},{"value":"ELO","label":"ELO - Elopement"},{"value":"E","label":"E - Expired"},{"value":"HHS","label":"HHS - Home with Home Health Services"},{"value":"HOM","label":"HOM - Home, Routine Discharge"},{"value":"ELOLWBS","label":"ELOLWBS - Left Without Being Seen"},{"value":"OPOBS","label":"OPOBS - OP Refer for OBS Services"},{"value":"SCOPE","label":"SCOPE - Transferred to Scope Room"}],
    downcodeReasons:[{"value":"hpi","label":"HPI"},{"value":"ros","label":"ROS"},{"value":"pfsh","label":"PFSH"},{"value":"exam","label":"Exam"}],
    cdiReasons:[{"value":"critical_care_medication","label":"Critical Care-Medication"},{"value":"critical_care_time_not_documented","label":"Critical Care-Time not Documented"},{"value":"cc_treatment_list","label":"CC Treatment List"},{"value":"cc_unsubstantiated","label":"CC Unsbustantiated"},{"value":"cc_decision_list","label":"CC decision list"},{"value":"management_reassessment_inadequate","label":"Management/Reassessment Inadequate"},{"value":"mdm_inadequate","label":"MDM inadequate"},{"value":"professional_cc_documentation_not_found","label":"Professional CC documentation Not Found"},{"value":"time_not_met","label":"Time Not Met"},{"value":"intra_service_time_missing","label":"Intra Service Time Missing for Moderate Sedation"},{"value":"burn_care_missing_order","label":"Burn Care Missing Order"},{"value":"discharge_summary_elements_not_met","label":"Discharge Summary Elements Not Met"},{"value":"ekg_order_missing","label":"EKG Order Missing"},{"value":"foley_cath_missing_order","label":"Foley Cath Missing Order"},{"value":"inappropriate_code_set_assigned","label":"Inappropriate Code Set Assigned"},{"value":"insufficient_md_ekg_interpretation","label":"Insufficient MD EKG Interpretation"},{"value":"insufficient_md_xray_interpretation","label":"Insufficient MD XRAY Interpretation"},{"value":"iv_medication_administration_missing_order","label":"IV Medication Administration Missing Order"},{"value":"split_application_missing_order","label":"Split Application Missing Order"},{"value":"straight_cath_missing_order","label":"Straight Cath Missing Order"},{"value":"smoking_cessation_missing_time","label":"Smoking Cessation Missing Time"},{"value":"ultrasound_documentation_deficient","label":"Ultrasound Documentation Deficient"}],
    deficientReasons:[{"value":"hpi_missing","label":"HPI Missing"},{"value":"ros_missing","label":"ROS Missing"},{"value":"pfsh_missing","label":"PFSH Missing"},{"value":"exam_missing","label":"Exam Missing"},{"value":"physician_signature","label":"Physician Signature"},{"value":"physician_attestation","label":"Physician Attestation"},{"value":"mlp_signature","label":"MLP Signature"},{"value":"orders","label":"Orders"},{"value":"mar","label":"Medication Administration Record (MAR)"},{"value":"nursing_documentation","label":"Nursing Documentation"},{"value":"cpt_code","label":"CPT Code/Charge Code"},{"value":"provider_signature_illegible","label":"Provider Signature Illegible"},{"value":"missing_teaching_provider","label":"Missing Teaching Provider Attestation for Resident"},{"value":"covid-19","label":"COVID-19"},{"value":"charge_entry_hold","label":"CHARGE ENTRY HOLD"},{"value ":"missing_locum","label":"Missing Locum Tenen"},{"value":"abacusone_inquiry","label":"AbacusOne Inquiry"}],
  },
  getters: {
    jwt: state => {
      return state.user.signInUserSession.accessToken.jwtToken;
    },
    signedIn: state => {
      return state.signedIn;
    },
    username: state => {
      return state.user.username;
    },
    userid: state => {
      return state.user.attributes.sub;
    },
    userprof: state => {
      return state.userInfo.profile;
    },
    userList: state => {
      return state.userList;
    },
    facList: state => {
      return state.facList;
    },
    companies: state => {
      return state.companies;
    },
    profiles: state => {
      return state.profiles;
    },
    facilities: state => {
      return state.facilities;
    },
    apps: state => {
      return state.apps;
    },
    chargetypes: state => {
      return state.chargeTypes;
    },
    codetypes: state => {
      return state.codeTypes;
    },
    tools: state => {
      return state.tools;
    },
    statuses: state => {
      return state.statuses;
    },
    notetypes: state => {
      return state.noteTypes;
    },
    dischargereasons: state => {
      return state.dischargeReasons;
    },
    downcodereasons: state => {
      return state.downcodeReasons;
    },
    cdireasons: state => {
      return state.cdiReasons;
    },
    deficientreasons: state => {
      return state.deficientReasons;
    },
  },
  mutations: {
    SET_SIDEBAR_DRAWER(state, payload) {
      state.Sidebar_drawer = payload;
    },
    SET_CUSTOMIZER_DRAWER(state, payload) {
      state.Customizer_drawer = payload;
    },
    SET_SIDEBAR_COLOR(state, payload) {
      state.SidebarColor = payload;
    },
    SET_NAVBAR_COLOR(state, payload) {
      state.navbarColor = payload;
    },
    SET_LAYOUT(state, payload) {
      state.setHorizontalLayout = payload;
    },
    updateSignedIn(state, newstate) {
      state.signedIn = newstate;
    },
    updateUser(state, newuser) {
      state.user = newuser;
    },
    updateUserInfo(state, newinfo) {
      state.userInfo = newinfo;
    },
    updateUserList(state, newusers) {
      state.userList = newusers;
    },
    updateFacList(state, newfacs) {
      state.facList = newfacs;
    },
  },
  actions: {
    updateSignedIn({
      commit
    }, payload) {
      commit("updateSignedIn", payload);
    },
    updateUser({
      commit
    }, payload) {
      commit("updateUser", payload);
    },
    async updateUserInfo({
      commit
    }, payload) {
      if (payload) {
        commit("updateUserInfo", payload);
      } else {
        //TODO: Update dev/prod based on url
        getData("https://ycd87x571j.execute-api.us-east-1.amazonaws.com/prod/users/byid/" + this.getters.userid, this.getters.jwt)
          .then((data) => {
            commit("updateUserInfo", data[0]);
          });
      }
    },
    async updateUserList({
      commit
    }, payload) {
      if (payload) {
        commit("updateUserInfo", payload);
      } else {
        //TODO: Update dev/prod based on url
        getData("https://ycd87x571j.execute-api.us-east-1.amazonaws.com/prod/users", this.getters.jwt)
          .then((data) => {
            commit("updateUserList", data);
          });
      }
    },
    async updateFacList({
      commit
    }, payload) {
      if (payload) {
        commit("updateFacList", payload);
      } else {
        //TODO: Update dev/prod based on url
        getData("https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/prod/facility", this.getters.jwt)
          .then((data) => {
            commit("updateFacList", data);
          });
      }
    },
  },
});

const getData = async function (url, jwt) {
  // Default options are marked with *
  const response = await fetch(url, {
    method: "GET",
    cache: "no-cache",
    headers: {
      "Content-Type": "application/json",
      "Authorization": jwt,
    },
    referrerPolicy: 'no-referrer',
  });
  return response.json(); // parses JSON response into native JavaScript objects
};